import React from 'react';
import { MCButton, MCText, View } from 'src/components/basic';

import { remCss } from 'src/components/mobile/utils';
import { BASE_ICONS } from 'src/components/svg';

export const HeaderBack = ({ onBack, title }) => {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: remCss(10),
        position: 'sticky',
        top: 0,
        zIndex: 1,
        paddingHorizontal: remCss(15),
        paddingVertical: remCss(10),
        backgroundColor: 'white'
      }}
    >
      <MCButton
        iconname={BASE_ICONS.BACK_ARROW}
        onClick={onBack}
        width={remCss(50)}
        height={remCss(50)}
        padding={1}
      />
      {typeof title === 'string' ? <MCText size={24} weight={600} label={title} /> : title}
    </View>
  );
};
